import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { Navigate, Route } from 'react-router-dom';

import CaseCreator from './CaseCreator';
import CaseEditor from './CaseEditor';
import CasesExplorer from './CasesExplorer';
import ClientMaterials from './ClientMaterials';
import Configuration from './Configuration';
import Guide from './Guide/Guide';
import KimQA from './Guide/KimQA';
import MatterCreator from './MatterCreator';
import MattersExplorer from './MattersExplorer';
import { OrganisationEditor } from './Organisations/OrganisationEditor';
import { OrganisationRuns } from './Organisations/OrganisationRuns';
import { OrganisationList } from './Organisations/OrganisationsList';
import { OrganisationUsers } from './Organisations/OrganisationUsers';
import UsageDashboard from './UsageDashboard';
import Users from './Users';

const Chronos = () => {
  return (
    <Routes>
      <Route path="matters" element={<MattersExplorer />} />
      <Route path="usage-dashboard" element={<UsageDashboard />} />
      <Route path="users" element={<Users />} />
      <Route path="configuration/*" element={<Configuration />} />
      <Route path="organisations" element={<OrganisationList />} />
      <Route path="organisation/:orgId" element={<OrganisationEditor />} />
      <Route path="organisation/:orgId/users" element={<OrganisationUsers />} />
      <Route path="organisation/:orgId/runs" element={<OrganisationRuns />} />
      <Route path="explore" element={<CasesExplorer />} />
      <Route path="case-creator" element={<CaseCreator />} />
      <Route path="matter-creator" element={<MatterCreator />} />
      <Route path="matter-editor/:matterId" element={<MatterCreator isEditMode={true} />} />
      <Route path="case-editor/*" element={<CaseEditor />} />
      <Route path="guide" element={<Guide />} />
      <Route path="kim-qa" element={<KimQA />} />
      <Route path="client-materials" element={<ClientMaterials />} />
      <Route path="*" element={<Navigate to="/app/chronos/matters" />} />
    </Routes>
  );
};

export default Chronos;
